export enum BackgroundTaskStatus {
  Pending = 0,
  Running = 1,
  Completed = 2,
  Failed = 3
}

export enum BackgroundTaskType {
  Clone = 0,
  Export = 1,
  Import = 2
}

export interface BackgroundTask {
  id: number;
  userId: number;
  taskType: BackgroundTaskType;
  status: BackgroundTaskStatus;
  entityName?: string;
  entityId?: number;
  errorMessage?: string;
  createdAt: string;
  startedAt?: string;
  completedAt?: string;
}
